import { render } from "./LocalDicomDevice.vue?vue&type=template&id=0ae5f1d5&scoped=true"
import script from "./LocalDicomDevice.vue?vue&type=script&lang=js"
export * from "./LocalDicomDevice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae5f1d5"]])

export default __exports__